import React from "react";
import { translate } from "../../../../../utils/Common";

const IncidentClosedByUser = ({ users = [], totalClosed = 0 }) => {
  if (users.length === 0) return null;

  const max = users[0]?.closed || 1;

  return (
    <div className="mt-4 w-full min-w-0">
      <h6 className="mb-2 text-sm font-semibold text-foreground">
        {translate("dashboard.insights.incidents.kpi.closedByUser")}
      </h6>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              <th className="py-2 pr-3 font-semibold">{translate("dashboard.insights.incidents.kpi.user")}</th>
              <th className="hidden w-2/5 py-2 pr-3 sm:table-cell" aria-hidden />
              <th className="py-2 pr-3 text-right font-semibold">{translate("dashboard.insights.incidents.kpi.closed")}</th>
              <th className="py-2 pr-3 text-right font-semibold">%</th>
              <th className="py-2 text-right font-semibold">{translate("dashboard.insights.incidents.kpi.avgTime")}</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.idClient ?? user.name} className="border-t border-border">
                <td className="py-2 pr-3 text-foreground">{user.name || "—"}</td>
                <td className="hidden py-2 pr-3 sm:table-cell">
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
                    <div className="h-full rounded-full bg-primary" style={{ width: `${(user.closed / max) * 100}%` }} />
                  </div>
                </td>
                <td className="py-2 pr-3 text-right font-semibold text-foreground">{user.closed}</td>
                <td className="py-2 pr-3 text-right text-muted-foreground">
                  {totalClosed ? `${Math.round((user.closed / totalClosed) * 1000) / 10}%` : "—"}
                </td>
                <td className="py-2 text-right text-muted-foreground">
                  {user.avgResolutionHours == null ? "—" : `${user.avgResolutionHours} h`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IncidentClosedByUser;
